import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import * as React from "react";
import {styled} from "@mui/material/styles";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import {OvertimeDayOfWork} from "../../model/OvertimeDayOfWork";
import {convertSecondsToHoursAndMinutes, formatIsoDateToString} from "../../TimeUtils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(() => ({
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));

interface OvertimeComponentProps {
    rows: OvertimeDayOfWork[]
    height: number | string
}

export default function OvertimeTableComponent(rows: OvertimeComponentProps) {
    return (
        <TableContainer component={Paper} style={{height: rows.height}}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data</StyledTableCell>
                        <StyledTableCell align="right">Łączny czas</StyledTableCell>
                        <StyledTableCell align="right">Nadgodziny</StyledTableCell>
                        <StyledTableCell align="right">Pozostałe nadgodziny</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.rows.map((row) => (
                        <StyledTableRow key={row.date}>
                            <StyledTableCell component="th" scope="row">
                                {formatIsoDateToString(row.date)}
                            </StyledTableCell>
                            <StyledTableCell align="right">{convertSecondsToHoursAndMinutes(row.totalTimeSpentSeconds)}</StyledTableCell>
                            <StyledTableCell align="right">{convertSecondsToHoursAndMinutes(row.overtimeTotalSeconds)}</StyledTableCell>
                            <StyledTableCell align="right">{convertSecondsToHoursAndMinutes(row.overtimeToTakeSeconds)}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}